const cases = {
	name: "Cases",
	// NOTE: idea how to handle variables picker
	// variables: { component: "SelectCase", handler: caseId => JSON.stringify({ $caseWhere1: { id: `${caseId}` } }) },
	query: `
  query templateCases($limit:Int $sort:sortInput $where:caseWhere $proposalWhere:proposalWhere $offerWhere: offerWhere){
    cases(limit:$limit sort:$sort where:$where){
       list {
         id
         holder {   
               ... on individual {
                 addresses { 
                 fields
                 fields2 { value }
                 type
                 }
                  contacts {
                 type value
                 }
                 chineseFirstName
                 chineseLastName
                 dateOfBirth
                 email
                 facts { type value { booleanValue dateValue stringValue numberValue }}
                 identities { type value }
                 name
                 telephoneNumber
                 salutation
                 relationships { type entity { name }  }
               }
               ... on company {
                 addresses { 
                  fields
                  fields2 { value }
                  type
                  }
                 contacts { type value }
                 facts { type value { booleanValue dateValue stringValue numberValue }}
                 identities { type value }
                 name
                 natureOfBusiness
                 registrationNumber
                 relationships { type entity { name } }
               }
             }
        insureds {
               ... on individual {
                 addresses { 
                  fields
                  fields2 { value }
                  type
                 }
                 contacts { type value }
                 chineseFirstName
                 chineseLastName
                 dateOfBirth
                 email
                 facts { type value { booleanValue dateValue stringValue numberValue }}
                 identities { type value }
                 name
                 telephoneNumber
                 salutation
                 relationships { type }
               }
               ... on company {
                addresses { 
                 fields
                 fields2 { value }
                 type
                 }
                contacts { type value }
                facts { type value { booleanValue dateValue stringValue numberValue }}
                identities { type value }
                name
                natureOfBusiness
                registrationNumber
                relationships { type entity { name } }
              }
              ... on object {
                addresses { 
                  fields
                  fields2 { value }
                  type
                  }
                contacts { type value }
                facts { type value { booleanValue dateValue stringValue numberValue }}
                identities { type value }
                name
                relationships { type entity { name }  }
              }
             }
         otherHolders {
               ... on individual {
                 addresses { 
                 fields
                  fields2 { value }
                 type
                 }
                  contacts {
                 type value
                 }
                 chineseFirstName
                 chineseLastName
                 dateOfBirth
                 email
                 facts { type value { booleanValue dateValue stringValue numberValue }}
                 identities { type value }
                 name
                 telephoneNumber
                 salutation
                 relationships { type }
               }
             }
        proposals(where: $proposalWhere) {
         id
         isIssued
         name
          basket(where: $offerWhere) {
            id
           endDate
           exclusions {
             id
           }
           offerNumber
           policyNumber
           exclusions { id codeName { code name }}
           premium {
               appliedDiscounts { flat ratio }
               appliedTaxes { code flat ratio }
               formattedPrice
               formattedOriginalPrice
               originalPrice
               loadings { flat id }
               paymentFrequency
             }
           product { 
             name
             productId { plan }
             pricing { currencyCode }
             type { name }
           }
           startDate
           endDate
           status
          }
         }
        }
      }
   }
`
}

export default cases
